const STAFF_EMAIL_DOMAINS = ['@addtocarrot.com', '@carrot.link', '@dupe.com']

const STAFF_EMAILS = [
  'i8ramin@gmail.com',
  'arnabg@gmail.com',
  'mariano.selvaggi81@gmail.com',
  'mariano.selvaggi.81@gmail.com',
  'gabilhartman@gmail.com',
]

/**
 * The signed-in user is staff (`useAuthUser().isAdmin`), by their email, as
 * the api's `isAdminEmail` (apps/api/src/lib/apiAuthHelpers.ts): keep the two
 * lists equal.
 * ⛔ A hint for what to show only: the api decides on a verified token.
 */
export function isStaffEmail(email: string | null | undefined): boolean {
  const normalized = email?.trim().toLowerCase()
  if (!normalized) return false
  return (
    STAFF_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain)) ||
    STAFF_EMAILS.includes(normalized)
  )
}

/**
 * The signed-in user is staff: a staff email that Firebase says is verified,
 * the same rule the api enforces (`isVerifiedAdmin`). Use this, not
 * `isStaffEmail` alone, so the UI never offers staff tools the api refuses.
 * ⛔ Still only a hint for what to show.
 */
export function isStaffUser(
  user: { email?: string | null; emailVerified?: boolean } | null | undefined
): boolean {
  return user?.emailVerified === true && isStaffEmail(user.email)
}
